module.exports = __webpack_public_path__ + "static/media/position-up.64ca63df.svg";